// src/components/reports/ModerationStats.jsx
import React from 'react';
import { AlertTriangle, Shield, MessageCircle, Eye } from 'lucide-react';

const ModerationStats = ({ 
  stats = {},
  contentType = 'all' // 'all', 'goget', 'message'
}) => {
  // Get appropriate stats based on content type
  const getStatsCards = () => {
    const baseStats = [
      {
        id: 'resolvedToday',
        label: 'Resolved Today',
        value: stats.resolvedToday || 0,
        icon: Shield,
        color: 'green'
      }
    ];
    
    switch(contentType) {
      case 'goget':
        return [
          {
            id: 'flagged',
            label: 'Flagged GoGets',
            value: stats.flagged || 0,
            icon: AlertTriangle,
            color: 'yellow'
          },
          {
            id: 'highSeverity',
            label: 'High Severity',
            value: stats.highSeverity || 0,
            icon: AlertTriangle,
            color: 'red'
          },
          {
            id: 'automated',
            label: 'Automated Flags',
            value: stats.automated || 0,
            icon: Eye,
            color: 'blue'
          },
          {
            id: 'userReported',
            label: 'User Reported',
            value: stats.userReported || 0,
            icon: Shield,
            color: 'green'
          }
        ];
      case 'message':
        return [
          {
            id: 'flaggedMessages',
            label: 'Flagged Messages',
            value: stats.flaggedMessages || 0,
            icon: MessageCircle,
            color: 'yellow'
          },
          {
            id: 'highSeverity',
            label: 'High Severity',
            value: stats.highSeverity || 0,
            icon: AlertTriangle,
            color: 'red'
          },
          ...baseStats
        ];
      default:
        return [
          {
            id: 'pending',
            label: 'Pending Review',
            value: stats.pending || 0,
            icon: AlertTriangle,
            color: 'yellow'
          },
          {
            id: 'inReview',
            label: 'In Review',
            value: stats.inReview || 0,
            icon: Eye,
            color: 'blue'
          },
          {
            id: 'highPriority',
            label: 'High Priority',
            value: stats.highPriority || 0,
            icon: AlertTriangle,
            color: 'red'
          },
          ...baseStats
        ];
    }
  };
  
  const getColorClasses = (color) => {
    const colors = {
      red: { bg: 'bg-red-50', text: 'text-red-600' },
      yellow: { bg: 'bg-yellow-50', text: 'text-yellow-600' },
      green: { bg: 'bg-green-50', text: 'text-green-600' },
      blue: { bg: 'bg-blue-50', text: 'text-blue-600' }
    };
    return colors[color] || colors.blue;
  };
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      {getStatsCards().map(stat => {
        const colorClasses = getColorClasses(stat.color);
        return (
          <div key={stat.id} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <div className="flex items-center">
              <div className={`p-2 ${colorClasses.bg} rounded-lg`}>
                <stat.icon className={`h-6 w-6 ${colorClasses.text}`} />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">{stat.label}</p>
                <h3 className="text-2xl font-bold text-gray-900">
                  {stat.value}
                </h3>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ModerationStats;